<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="submit-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="title t-submit"></div>

                    <ul class="item-list">
                        <li v-for="(item,index) in reward_list" :key="index">
                            <div class="pic">
                                <div class="pic-wrapper"
                                @mouseover="$tips_on($event,item.id,'img')"
                                @mouseleave="$tips_off()"
                                @click="$item_tips(item.id,'img')">
                                    <game-item :id="item.id" :locked="true"></game-item>
                                </div>
                            </div>
                            <div class="item-name">{{ item.name }}</div>
                        </li>
                    </ul>

                    <p class="notice">投票完成即可领取探索礼包，成功抓住“盗剑之人”还可获得缉凶礼包。</p>
                    <p class="tips">奖励将于游戏内版本更新后发放</p>

                    <div class="u-btn submit" @click="submit"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            visible : false,
            vote : 0,
            code : 0,
            uflag : 0,
            reward_list : [
                {
                    id : 'LM38',
                    name : '探索礼包',
                },
                {
                    id : 'LM39',
                    name : '缉凶礼包',
                },                                
            ],
        }
    },
    created (){
        //this.render();
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        submit (){
            //TODO
            if(this.code == 0)return this.$toast('您尚未选择人物');

            this.$axios.post(globalThis.ajax_url_map.riddle,{
                code : this.code,
            })
            .then(
                res => {
                    this.destroyElement();
                    this.$toast('投票成功');

                    let new_data = this.uflag > 10 ? (this.code + 10) : this.code;

                    this.$update_userType_select(new_data);
                },
                rej => {
                    this.$toast(rej.message);
                },
            )
        },
    }    
}
</script>

<style scoped>
.submit-modal{
    width: 734px;
    height: 426px;
    background-image: url(~@/assets/images/pc/vote/bg-modal-2.png);
}

.u-btn.close{
    top: 25px;
    right: 40px;
    width: 32px;
    height: 34px;
    background-image: url(~@/assets/images/pc/vote/btn-close.png);
}

.t-submit{
    width: 626px;
    height: 58px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/vote/title-2.png);
}

.u-btn.submit{
    width: 214px;
    height: 51px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/vote/btn-ok.png); 
}

.item-list{
    display: flex;
    justify-content: space-around;
    padding: 0 190px;
    margin: 25px auto 15px;
}

.item-list li>.pic{
    display: flex;
    width: 81px;
    height: 81px;
    background-color: #23262d;
    border: 3px solid #000000;
    justify-content: center;
    align-items: center;
}

.pic-wrapper{
    width: 64px;
    height: 64px;
}

.item-list .item-name{
    font-size: 20px;
    text-align: center;
    color: #f2edd9;
}

.notice{
    margin: 0 60px 5px;
    font-size: 20px;
    color: #f2edd9;
    text-align: center;
}

.tips{
    margin: 0 60px 15px;
    font-size: 16px;
    color: #f2edd9;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SubmitModal/submitModal.vue